module.exports = __webpack_public_path__ + "static/nothing-to-lose-2720278bde3cf45ba3e1147fed338025.jpg";